import { SVG } from './SVG';
const IconLatestResearch = ({
  className,
  style,
  width,
  height,
  showBoxShadow = true,
  showBackground = true,
  color = 'white',
  padding = true,
}) => {
  const borderRadius = Math.min(width, height) * 0.25;
  const lineStyles = { stroke: color, strokeMiterlimit: '10', strokeLinecap: 'round', strokeLinejoin: 'round' };

  return (
    <div
      style={{
        ...(showBackground ? { background: 'linear-gradient(225deg, #595FAA 0%, #715A9C 100%)' } : {}),
        ...(showBoxShadow
          ? {
              borderRadius,
              boxShadow:
                '0px 50px 40px rgba(0, 0, 0, 0.07), 0px 20.8888px 16.711px rgba(0, 0, 0, 0.0503198), 0px 11.1682px 8.93452px rgba(0, 0, 0, 0.0417275), 0px 6.26078px 5.00862px rgba(0, 0, 0, 0.035), 0px 3.32505px 2.66004px rgba(0, 0, 0, 0.0282725), 0px 1.38363px 1.1069px rgba(0, 0, 0, 0.0196802)',
            }
          : {}),

        ...(padding
          ? {
              width,
              minWidth: width + 'px',
              height,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }
          : {}),
        ...style,
      }}
      className={className}
    >
      <SVG
        width={padding ? (27 / 52) * width : width}
        height={padding ? (33 / 52) * height : height}
        viewBox="0 0 27 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'relative', left: '-1px' }}
      >
        <path
          d="M3.62427 13.0632V3.79048C3.62427 2.45247 4.71111 1.32031 6.10849 1.32031H20.0822V5.28287C20.0822 6.56941 21.1173 7.65011 22.463 7.65011H26.4481V29.9845C26.4481 31.3225 25.3612 32.4547 23.9638 32.4547H6.10849C4.76287 32.4547 3.62427 31.374 3.62427 29.9845C3.62427 29.9845 3.62427 24.465 3.62427 20.5059"
          {...lineStyles}
        />
        <path d="M20.134 1.32031L26.4999 7.65011" {...lineStyles} />
        <path
          d="M14.9067 25.6618C19.4229 25.6618 23.084 22.0215 23.084 17.5309C23.084 13.0403 19.4229 9.3999 14.9067 9.3999C10.3906 9.3999 6.72949 13.0403 6.72949 17.5309C6.72949 22.0215 10.3906 25.6618 14.9067 25.6618Z"
          {...lineStyles}
        />
        <path d="M10.6628 21.7506C12.9918 24.0664 16.7699 24.0664 19.0989 21.7506C21.4278 19.4348 21.4278 15.6781 19.0989 13.3623C16.7699 11.0465 12.9918 11.0465 10.6628 13.3623" />
        <path
          d="M10.6628 21.7506C12.9918 24.0664 16.7699 24.0664 19.0988 21.7506C21.4278 19.4348 21.4278 15.6781 19.0988 13.3623C16.7699 11.0465 12.9918 11.0465 10.6628 13.3623"
          {...lineStyles}
        />
        <path d="M6.87003 24.8011L8.15088 26.0747L10.0173 24.2189L8.73641 22.9453L6.87003 24.8011Z" {...lineStyles} />
        <path
          d="M1.29539 31.4772L1.3989 31.5801C1.91644 32.0948 2.79627 32.0948 3.31382 31.5801L8.54104 26.3825L6.5226 24.3755L1.29539 29.6246C0.77784 30.1392 0.77784 30.9626 1.29539 31.4772Z"
          {...lineStyles}
        />
        <path
          d="M17.8568 18.3539C18.6858 18.3539 19.3577 17.6858 19.3577 16.8615C19.3577 16.0373 18.6858 15.3691 17.8568 15.3691C17.0279 15.3691 16.356 16.0373 16.356 16.8615C16.356 17.6858 17.0279 18.3539 17.8568 18.3539Z"
          {...lineStyles}
        />
        <path
          d="M10.7148 18.3539C11.5437 18.3539 12.2156 17.6858 12.2156 16.8615C12.2156 16.0373 11.5437 15.3691 10.7148 15.3691C9.88584 15.3691 9.21387 16.0373 9.21387 16.8615C9.21387 17.6858 9.88584 18.3539 10.7148 18.3539Z"
          {...lineStyles}
        />
        <path
          d="M7.14349 20.8242C7.68658 20.8242 8.12683 20.3864 8.12683 19.8464C8.12683 19.3064 7.68658 18.8687 7.14349 18.8687C6.60041 18.8687 6.16016 19.3064 6.16016 19.8464C6.16016 20.3864 6.60041 20.8242 7.14349 20.8242Z"
          {...lineStyles}
        />
        <path
          d="M14.2858 20.8242C14.8289 20.8242 15.2692 20.3864 15.2692 19.8464C15.2692 19.3064 14.8289 18.8687 14.2858 18.8687C13.7427 18.8687 13.3025 19.3064 13.3025 19.8464C13.3025 20.3864 13.7427 20.8242 14.2858 20.8242Z"
          {...lineStyles}
        />
        <path
          d="M3.57242 18.3539C4.40133 18.3539 5.0733 17.6858 5.0733 16.8615C5.0733 16.0373 4.40133 15.3691 3.57242 15.3691C2.7435 15.3691 2.07153 16.0373 2.07153 16.8615C2.07153 17.6858 2.7435 18.3539 3.57242 18.3539Z"
          {...lineStyles}
        />
        <path d="M9.57607 17.8906L7.91992 19.2286" {...lineStyles} />
        <path d="M4.71118 17.8906L6.36733 19.2286" {...lineStyles} />
        <path d="M16.7182 17.8906L15.062 19.2286" {...lineStyles} />
        <path d="M11.8533 17.8906L13.5094 19.2286" {...lineStyles} />
        <path d="M17.6497 4.45947H6.72949V6.26064H17.6497V4.45947Z" {...lineStyles} />
        <path d="M26.4999 28.9038C26.4999 28.9038 16.0245 28.9038 8.88989 28.9038" {...lineStyles} />
      </SVG>
    </div>
  );
};

/* eslint-disable react/display-name */
export { IconLatestResearch as default, IconLatestResearch };
